// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__27ewf","content":"LoadingAlert_content__1resX"};